"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClampedText = exports.getTruncatedContent = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const constants_1 = require("../constants");
const DEFAULT_MAXLINES_VALUE = 1;
const DEFAULT_MAXCHARS_VALUE = 40;
exports.getTruncatedContent = (content, maxChars) => {
    if (content) {
        let trucatedContent = content;
        if (maxChars && content) {
            trucatedContent = content.length > maxChars ? `${content.substr(0, maxChars)} ...` : content;
        }
        return trucatedContent;
    }
    return constants_1.EMPTY_STRING;
};
exports.ClampedText = (props) => {
    const { content, maxChars = DEFAULT_MAXCHARS_VALUE, maxLines = DEFAULT_MAXLINES_VALUE } = props;
    const useStyles = makeStyles_1.default({
        customClamp: {
            width: '100%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: '-webkit-box',
            WebkitLineClamp: maxLines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        },
    });
    const classes = useStyles();
    return (react_1.default.createElement(material_1.Box, { className: classes.customClamp },
        react_1.default.createElement(material_1.Typography, { variant: "body2" }, exports.getTruncatedContent(content, maxChars))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xhbXBlZFRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DbGFtcGVkVGV4dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBQTBCO0FBQzFCLDRDQUFnRDtBQUNoRCx3RUFBZ0Q7QUFFaEQsNENBQTRDO0FBUTVDLE1BQU0sc0JBQXNCLEdBQVcsQ0FBQyxDQUFDO0FBQ3pDLE1BQU0sc0JBQXNCLEdBQVcsRUFBRSxDQUFDO0FBRTdCLFFBQUEsbUJBQW1CLEdBQUcsQ0FBQyxPQUEyQixFQUFFLFFBQWdCLEVBQVUsRUFBRTtJQUMzRixJQUFJLE9BQU8sRUFBRTtRQUNYLElBQUksZUFBZSxHQUFXLE9BQU8sQ0FBQztRQUN0QyxJQUFJLFFBQVEsSUFBSSxPQUFPLEVBQUU7WUFDdkIsZUFBZSxHQUFHLE9BQU8sQ0FBQyxNQUFNLEdBQUcsUUFBUSxDQUFDLENBQUMsQ0FBQyxHQUFHLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQztTQUM5RjtRQUNELE9BQU8sZUFBZSxDQUFDO0tBQ3hCO0lBQ0QsT0FBTyx3QkFBWSxDQUFDO0FBQ3RCLENBQUMsQ0FBQztBQUVXLFFBQUEsV0FBVyxHQUFHLENBQUMsS0FBWSxFQUFFLEVBQUU7SUFDMUMsTUFBTSxFQUFFLE9BQU8sRUFBRSxRQUFRLEdBQUcsc0JBQXNCLEVBQUUsUUFBUSxHQUFHLHNCQUFzQixFQUFFLEdBQUcsS0FBSyxDQUFDO0lBQ2hHLE1BQU0sU0FBUyxHQUFHLG9CQUFVLENBQUM7UUFDM0IsV0FBVyxFQUFFO1lBQ1gsS0FBSyxFQUFFLE1BQU07WUFDYixZQUFZLEVBQUUsVUFBVTtZQUN4QixVQUFVLEVBQUUsUUFBUTtZQUNwQixPQUFPLEVBQUUsYUFBYTtZQUN0QixlQUFlLEVBQUUsUUFBUTtZQUN6QixlQUFlLEVBQUUsVUFBVTtZQUMzQixRQUFRLEVBQUUsUUFBUTtTQUNuQjtLQUNGLENBQUMsQ0FBQztJQUVILE1BQU0sT0FBTyxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBRTVCLE9BQU8sQ0FDTCw4QkFBQyxjQUFHLElBQUMsU0FBUyxFQUFFLE9BQU8sQ0FBQyxXQUFXO1FBQ2pDLDhCQUFDLHFCQUFVLElBQUMsT0FBTyxFQUFDLE9BQU8sSUFBRSwyQkFBbUIsQ0FBQyxPQUFPLEVBQUUsUUFBUSxDQUFDLENBQWMsQ0FDN0UsQ0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=